/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
const BYPASS_SELECT_ORGANIZATION_LIST = [
  '/onboarding',
  '/select-organization',
  '/marketplace-conversion',
  '/home?invitationOrganizationId=', // should bypass select organization if user is accepting an invite to a new organization
] as const

export const shouldBypassSelectOrganization = (redirectTo: string): boolean =>
  BYPASS_SELECT_ORGANIZATION_LIST.some((path) => redirectTo.startsWith(path))
